import Vue from 'vue';

Vue.component('talmundoColorPicker', require('@admin/shared/components/ColorPicker.vue').default);
Vue.component('talmundoSwitch', require('@admin/shared/components/Switch.vue').default);
Vue.component('talmundoInputNumber', require('@admin/shared/components/InputNumber.vue').default);
Vue.component('talmundoSelect', require('@admin/shared/components/Select.vue').default);
Vue.component('talmundoInput', require('@admin/shared/components/Input.vue').default);
